import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	uids: data.userIds,
	removeGroups: data.activePartners.map((p: PropertyType) => p.value),
	removeProperties: data.activePermissions,
	removeRoles: data.activeRoles,
});
